// Interface para resultado IRRF
interface IRRFResult {
  readonly valor: number;
  readonly aliquota: number;
  readonly baseCalculo: number;
  readonly deducaoDependentes: number;
}

// Interface para detalhes dos impostos do Lucro Presumido
interface DetalhesImpostosPresumido {
  readonly irpj: number;
  readonly csll: number;
  readonly pis: number;
  readonly cofins: number;
  readonly iss: number;
}

// Interface para resultado completo
type PJResultsType = {
  readonly tipo: 'MEI' | 'Simples Nacional' | 'Lucro Presumido';
  readonly remuneracaoBruta: number;
  readonly regime: string;
  
  // Campos específicos por regime
  readonly anexo?: string;                              // Simples Nacional
  readonly tipoAtividade?: string;                      // Lucro Presumido
  readonly aliquota?: number;
  
  // Impostos específicos
  readonly dasMEI?: number;                             // MEI
  readonly impostoSimples?: number;                     // Simples Nacional
  readonly impostoPresumido?: number;                   // Lucro Presumido
  readonly detalhesImpostos?: DetalhesImpostosPresumido; // Lucro Presumido
  
  // Pró-labore e encargos
  readonly proLabore: number;
  readonly proLaboreInformado: boolean;
  readonly inssProLabore: number;
  readonly irrf: IRRFResult;
  
  // Totais
  readonly totalDescontos: number;
  readonly valorLiquido: number;
  readonly percentualLiquido: number;
  readonly observacoes: string[];
};

// Interface para dados de entrada do formulário
interface PJInputData {
  readonly regime: string;
  readonly remuneracaoBruta: string;
  readonly ramoAtividade: string;
  readonly atividadeMEI: string;
  readonly aliquotaPersonalizada: boolean;
  readonly aliquotaPersonalizadaValor: string;
  readonly proLabore: string;
  readonly numeroDependentes: string;
}

// Mensagens de validação
const ValidationMessages = {
  REGIME_OBRIGATORIO: "Selecione o regime tributário.",
  REMUNERACAO_OBRIGATORIA: "Informe uma remuneração bruta válida.",
  REMUNERACAO_INVALIDA: "Remuneração bruta deve ser maior que zero.",
  LIMITE_MEI_EXCEDIDO: "Remuneração excede o limite do MEI.",
  RAMO_ATIVIDADE_OBRIGATORIO: "Selecione o ramo/tipo de atividade.",
  ERRO_CALCULO: "Erro no cálculo. Verifique os dados informados.",
} as const;

// Export das interfaces e tipos
export type {
  PJResultsType,
  PJInputData,
  IRRFResult,
  DetalhesImpostosPresumido,
};

export { ValidationMessages };